import React from 'react';
import {connect} from "react-redux";
import {TableCell, TableRow, Tooltip} from "@material-ui/core";
import {countryMap} from "../../../util/Util";
import { useTranslation } from 'react-i18next';
import {DeleteOutline, EditOutlined, RestoreFromTrashOutlined, SwapHoriz} from "@material-ui/icons";

const tooltipIcon = (icon, tooltipText) => {
    return <Tooltip title={tooltipText}>{icon}</Tooltip>;
}


const PlayersPageRow = (props) => {
    const {entryId} = props;
    const entry = props.entryMap[entryId];
    const cells = [];
    const {t} = useTranslation('messages');

    if (entry.players) {
        entry.players.forEach((p) => {
            const country = countryMap[p.country] ? countryMap[p.country].name : p.country;
            cells.push(<TableCell key={p.id + "lastName"} >{p.lastName}</TableCell>);
            cells.push(<TableCell key={p.id + "firstName"}>{p.firstName}</TableCell>);
            cells.push(<TableCell key={p.id + "gender"}>{t('gender.' + p.gender)}</TableCell>);
            cells.push(<TableCell key={p.id + "country"}>{country}</TableCell>);
        });
    }
    let swapIcon = null;
    let deleteIcon = null;
    let editIcon = null;
    if (entry.deleted) {
        deleteIcon = tooltipIcon(<RestoreFromTrashOutlined onClick={props.handleUndeleteEntry}/>, "Undelete");
    } else {
        deleteIcon = tooltipIcon(<DeleteOutline onClick={props.handleDeleteEntry} />, "Delete");
        if (entry.players.length === 2) {
            swapIcon = tooltipIcon(<SwapHoriz onClick={(e) => props.handleSwapEntry(entry.id)}/>, "Swap");
        }
        editIcon = tooltipIcon(<EditOutlined onClick={props.handleEditEntry} />, "Edit");
    }
    cells.push(<TableCell key={entry.id + 'actions'}>{swapIcon}{editIcon}{deleteIcon}</TableCell>);


    return (
        <TableRow
            hover
            key={entry.id}
        >
            {cells}
        </TableRow>
    );
};

const mapStateToProps = (state) => {
    return {
        entryMap: state.root.playersPageEntryMap
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayersPageRow);